export function convertDurationToSeconds(input: string): number {
  // Modified regex to accept any word as the unit
  const regex = /^(\d+)\s*([a-zA-Z]+?)s?$/;
  const match = input.match(regex);

  if (!match) {
    throw new Error('Invalid input format: Missing number or unit');
  }

  const [, valueStr, unit] = match;
  const value = parseInt(valueStr, 10);

  switch (unit.toLowerCase()) {
    case 'minute':
      return value * 60;
    case 'hour':
      return value * 3600;
    case 'day':
      return value * 86400;
    case 'week':
      return value * 604800;
    default:
      throw new Error(`Unsupported time unit: "${unit}"`);
  }
}
